import { render, staticRenderFns } from "./CourseDayActions.vue?vue&type=template&id=64aeb514&lang=pug&"
import script from "./CourseDayActions.vue?vue&type=script&lang=js&"
export * from "./CourseDayActions.vue?vue&type=script&lang=js&"
import style0 from "./CourseDayActions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
